var user = null

export function getUser() {
    return new Promise((resolve) => {
        if (user) {
            resolve(user)
            return
        }
        authFetch("/auth/user").then(resp => {
            if (resp.status === 200) {
                resp.json().then(u => {
                    user = u
                    resolve(user)
                })
                return
            }
            user = null
            // reject()
        })
    })
}

export function login(username, password) {
    return new Promise((resolve, reject) => {
        fetch("/auth/login", {
            method: "post", body: JSON.stringify({
                username,
                password
            })
        }).then(resp => {
            switch (resp.status) {
                case 200:
                    getUser().then(u => {
                        resolve(u)
                        return
                    })
                    break
                default:
                    reject()
            }
        })
    }
    )
}


export function authFetch(path, opts) {
    opts = opts || {}
    return new Promise((resolve) => {
        fetch(path, opts).then(resp => {
            switch (resp.status) {
                case 401:
                    logout()
                    break;
                default:
                    resolve(resp)
            }
        })
    })
}

export function logout() {
    user = null
    location = "/"
    authFetch("/auth/logout")
}
